export default {
  UNKNOWN: '100000',
  TAMARA_IS_DISABLE: '100001',
  REACHED_CREDIT_LIMIT: '100002',
  NOT_PAID_OVERDUE: '100003',
  EXCEED_SAFETY_THRESHOLD: '100004',
  EXCEED_VELOCITY_THRESHOLD: '100005',
  MANUAL_DECLINED: '100006',
  REACHED_DOWN_PAYMENT_THRESHOLD: '100007',
  NUMBER_IS_BLACKLIST: '100008',
  VPN_USED: '100009',
  OUT_OF_SERVICE_AREAS: '100010',
  FIRST_PAYMENT_IS_NOT_PAID: '100011',
  MULTIPLE_ACCOUNTS: '100012',
  SUSPICIOUS_TIME: '100013',
  NOT_ENOUGH_AGE: '100014',
  ID_USED_BY_ANOTHER_ACCOUNT: '100015',
  EXCEED_ELM_RETRIES: '100016',
  YOUTH_REACHED_CREDIT_LIMIT: '100017',
  MATURE_REACHED_CREDIT_LIMIT: '100018',
  EXCEED_SANCTION_LIST_THRESHOLD: '100019',
  ITEM_VIOLATED: '100020',
  SKU_BLOCKED: '100021',
  POOR_CREDIT_SCORE: '100022',
  REJECTED_BASED_ON_SIMAH_SCORE: '100022',
  INVALID_RESIDENT_STATUS: '100023',
  BLACKLIST_PHONE_NUMBER: '100024',
  BLACKLIST_ITEM: '100025',
  MISSING_ID_NUMBER: '100026',
  PAYMENT_OPTIONS_NOT_AVAILABLE: '100027',
  SEON_DECLINED_ORDER: '100028',
  INVALID_ID: '100029',
  CREDIT_LIMIT_BY_PASSING_FRAUD_VIOLATION: '100030',
  ORDER_VALUE_BEYOND_LIMIT: '100031',
  NAFATH_WAS_REJECTED: '100037',
  NAFATH_EXCEED_MAX_ATTEMPT: '100039',
  NAFATH_REQUEST_STILL_ACTIVE: '100041',
  NAFATH_REQUEST_WAS_FAILED: '100042',
  NAFATH_ID_EXTRACTION_FAILED: '100043',
  TAHAQAQ_VERIFY_FAILED: '100046',
  YAKEEN_VERIFY_FAILED: '100047',
  IVR_CONFIRMATION_FAILED: '100050',
  IVR_REACHED_MAXIMUM_ATTEMPT: '100051',
  TAHAQAQ_REVERIFY_FAILED: '100045',
  KYC_NAFATH_WAS_REJECT: '100060',
  VERIFICATION_UNSUCCESSFUL: '100070',
  SUBSCRIPTION_SERVICE_DOWN: '100080',

  /* new codes from MVP-2157 */
  DECLINED_D_DO_NOT_HONOUR: '20005',
  INSUFFICIENT_FUNDS: '20051',
  SUSPECTED_FRAUD: '20059',
  EXPIRED_CARD: '20054',
  EXPIRED_CARD_STR: 'expired_card',
  SYSTEM_3DS_MALFUNCTION: '20153',
  RESTRICTED_CARD: '20062',

  // Lean connect
  LEAN_MAX_ATTEMPTS_EXCEEDED: '100053',
  LEAN_SESSION_EXPIRED: '100052',
  LEAN_ACCOUNT_DUPLICATED: '100054',
  LEAN_ACCOUNT_MISMATCH: '100055',

  // Uqudo verification
  UQUDO_RETRY_LIMITED: '51009000',
  UQUDO_MISSING_IDENTITY_DOCUMENT: '51009001',
  UQUDO_INVALID_DOCUMENT_TYPE: '51009002',
  UQUDO_DOCUMENT_NOT_VERIFIED: '51009003',
  UQUDO_MISSING_IDENTITY_NUMBER: '51009004',
  UQUDO_IDENTITY_NUMBER_ALREADY_EXIST: '51009005',
  UQUDO_INVALID_TOKEN_SIGNATURE: '51009006',
  UQUDO_EXPIRED_TOKEN: '51009007',
  UQUDO_FACIAL_THRESHOLD: '51009009',
  UQUDO_FACE_ALREADY_MATCHED_FOR_ANOTHER_ID: '51009010',
  UQUDO_RE_VERIFICATION_NATIONAL_ID_MISMATCH: '51009014',
  UQUDO_RE_VERIFICATION_DOB_MISMATCH: '51009015',
  UQUDO_NATIONAL_ID_NUMBER_INVALID: '51009016',
  // UAE kyc  verification
  UAE_KYC_GENERIC_MESSAGE: '51009200',
  UAE_KYC_ID_EXPIRED: '51009201',
  UAE_KYC_ID_VERIFICATION_FAILED: '51009203',
  UAE_KYC_ID_VERIFICATION_INCOMPLETE: '51009202',

  // Checkout flow
  CHECKOUT_REPAYMENT_SERVICE_DISABLED: '510098020',

  CARDHOLDER_FAILED_3D_SECURE_AUTHENTICATION: '20151',
  INVALID_CARD_NUMBER: '20014',
  ISSUER_OR_SWITCH_IS_INOPERATIVE: '20091',
  CLOSED_ACCOUNT: '30046',
  TRANSACTION_NOT_PERMITTED_TO_CARDHOLDER: '20057',
  INVALID_VALUE_AMOUNT: '20013',

  CVV2_FAILURE: '200N7',
  USER_IS_UNDERAGE: '100119',

  CARD_IS_PREPAID: 'card_is_prepaid',
  CARD_IS_PREPAID_2: '80100',

  DELINQUENT_CUSTOMER: 'card_is_linked_to_delinquent_customer',
}
